import { useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, Trash, Image as ImageIcon } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { AuthImage } from "@/components/AuthImage";
import { uploadFile } from "@/components/Attachments";
import { api, errMsg } from "@/lib/api";

export default function ProductPhoto({ product, onChanged }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const fid = product.photo_file_id;

  const onPick = async (e) => {
    const f = e.target.files[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try {
      await uploadFile("product_photo", product.id, f);
      toast.success("Ürün fotoğrafı güncellendi");
      onChanged();
    } catch (err) {
      toast.error(errMsg(err));
    }
    setBusy(false);
  };
  const remove = async () => {
    try {
      await api.delete(`/files/${fid}`);
      toast.success("Fotoğraf kaldırıldı");
      onChanged();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <div className="panel flex flex-col items-center gap-3 p-4 sm:flex-row" data-testid="product-photo-panel">
      <div className="h-32 w-32 shrink-0 overflow-hidden border border-border bg-muted/40">
        {fid ? <AuthImage fileId={fid} alt={product.name} className="h-full w-full" testid="product-photo-image" />
          : <div className="flex h-full w-full items-center justify-center text-muted-foreground" data-testid="product-photo-empty"><ImageIcon size={36} /></div>}
      </div>
      <div className="flex-1 text-center sm:text-left">
        <h3 className="font-display text-lg font-bold">Ürün Fotoğrafı</h3>
        <p className="text-[11px] text-muted-foreground">Stok listesinde ve ürün kartında görünür. JPG, PNG veya WEBP (en fazla 15 MB).</p>
        <div className="mt-3 flex flex-wrap justify-center gap-2 sm:justify-start">
          <input ref={input} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={onPick} data-testid="product-photo-input" />
          <Button size="sm" disabled={busy} onClick={() => input.current?.click()} className="rounded-[4px] bg-teal-700 hover:bg-teal-800" data-testid="product-photo-upload-button">
            <Camera /> {busy ? "Yükleniyor…" : fid ? "Fotoğrafı Değiştir" : "Fotoğraf Yükle"}
          </Button>
          {fid && <Button size="sm" variant="ghost" onClick={remove} className="text-red-600" data-testid="product-photo-remove-button"><Trash /> Kaldır</Button>}
        </div>
      </div>
    </div>
  );
}
